import React, { useState, useEffect } from 'react';
import axios from 'axios';

const JobTitlesAdmin = () => {
  const [jobTitles, setJobTitles] = useState([]);
  const [newJobTitle, setNewJobTitle] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    loadJobTitles();
  }, []);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('admin_token');
    return {
      'Authorization': `Bearer ${token}`
    };
  };

  const loadJobTitles = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get('/api/admin/job-titles', {
        headers: getAuthHeaders()
      });
      setJobTitles(response.data);
    } catch (error) {
      showMessage('خطا در بارگذاری عناوین شغلی', 'error');
    }
    setIsLoading(false);
  };

  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: '', type: '' }), 3000);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newJobTitle.trim()) return;

    try {
      await axios.post('/api/admin/job-titles', 
        { name: newJobTitle.trim() },
        { headers: getAuthHeaders() }
      );
      
      setNewJobTitle('');
      loadJobTitles();
      showMessage('عنوان شغلی با موفقیت اضافه شد', 'success');
    } catch (error) {
      showMessage(error.response?.data?.error || 'خطا در افزودن عنوان شغلی', 'error');
    }
  };

  const handleEdit = (id, name) => {
    setEditingId(id);
    setEditingName(name);
  };

  const handleUpdate = async (id) => {
    if (!editingName.trim()) return;

    try {
      await axios.put(`/api/admin/job-titles/${id}`, 
        { name: editingName.trim() },
        { headers: getAuthHeaders() }
      );
      
      setEditingId(null);
      setEditingName('');
      loadJobTitles();
      showMessage('عنوان شغلی با موفقیت ویرایش شد', 'success');
    } catch (error) {
      showMessage(error.response?.data?.error || 'خطا در ویرایش عنوان شغلی', 'error');
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`آیا مطمئن هستید که می‌خواهید عنوان شغلی "${name}" را حذف کنید؟`)) {
      return;
    }

    try {
      await axios.delete(`/api/admin/job-titles/${id}`, {
        headers: getAuthHeaders()
      });
      
      loadJobTitles();
      showMessage('عنوان شغلی با موفقیت حذف شد', 'success');
    } catch (error) {
      showMessage(error.response?.data?.error || 'خطا در حذف عنوان شغلی', 'error');
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditingName('');
  };

  return (
    <div className="job-titles-admin">
      <h2>مدیریت عناوین شغلی</h2>
      
      {message.text && (
        <div className={`result-message ${message.type}`}>
          {message.text}
        </div>
      )}

      {/* Add new job title form */}
      <div className="add-job-title">
        <h3>افزودن عنوان شغلی جدید</h3>
        <form onSubmit={handleAdd} className="form-row">
          <div className="form-col">
            <input
              type="text"
              value={newJobTitle}
              onChange={(e) => setNewJobTitle(e.target.value)}
              placeholder="نام عنوان شغلی را وارد کنید"
              required
            />
          </div>
          <div className="form-col" style={{ flex: '0 0 auto' }}>
            <button type="submit" disabled={isLoading || !newJobTitle.trim()}>
              افزودن
            </button>
          </div>
        </form>
      </div>

      {/* Job titles list */}
      <div className="job-titles-list">
        <h3>عناوین شغلی موجود ({jobTitles.length})</h3>
        
        {isLoading ? (
          <div className="loading">در حال بارگذاری...</div>
        ) : jobTitles.length === 0 ? (
          <div className="no-data">هیچ عنوان شغلی ثبت نشده است</div>
        ) : (
          <div className="job-titles-table">
            {jobTitles.map((job) => (
              <div key={job.id} className="job-title-row">
                <div className="job-title-info">
                  {editingId === job.id ? (
                    <input
                      type="text"
                      value={editingName}
                      onChange={(e) => setEditingName(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') handleUpdate(job.id);
                        if (e.key === 'Escape') cancelEdit();
                      }}
                      autoFocus
                    />
                  ) : (
                    <span className="job-title-name">{job.name}</span>
                  )}
                </div>
                
                <div className="job-title-actions">
                  {editingId === job.id ? (
                    <>
                      <button 
                        onClick={() => handleUpdate(job.id)}
                        className="btn-save"
                        disabled={!editingName.trim()}
                      >
                        ذخیره
                      </button>
                      <button onClick={cancelEdit} className="btn-cancel">
                        لغو
                      </button>
                    </>
                  ) : (
                    <>
                      <button 
                        onClick={() => handleEdit(job.id, job.name)}
                        className="btn-edit"
                      >
                        ویرایش
                      </button>
                      <button 
                        onClick={() => handleDelete(job.id, job.name)}
                        className="btn-delete"
                      >
                        حذف
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default JobTitlesAdmin;